import { Box } from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

export const StyledMenuDesktopWrapper = styled(Box)({
  display: 'none',
  '@media (min-width: 1367px)': {
    display: 'block',
  },
});
